module.exports = __webpack_public_path__ + "img/ic_12_next_white.45dc34d1.svg";